import { render, staticRenderFns } from "./mostrarStockModal.vue?vue&type=template&id=12241afc&"
import script from "./mostrarStockModal.vue?vue&type=script&lang=js&"
export * from "./mostrarStockModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QTable,QBtn} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QTable,QBtn})
